<template>
  <li v-if="!childrenLinks && isHeader" :class="[{headerLink: true}, className]">
    <router-link v-if="!external" :to="link">
      <span class="icon">
        <i v-if="iconName" :class="fullIconName"></i>
        <img v-if="iconSrc" :src="iconSrc" width="25" height="25">
      </span>
      <!--{{header}} <sup v-if="label" class="headerLabel">{{label}}</sup>-->
      &nbsp;
      <b-badge v-if="greendot" class="badge rounded-f" variant="warning" pill>{{badge}}</b-badge>
    </router-link>

    <a v-if="external" :href="link" target="_blank">
      <span class="icon">
        <i v-if="iconName" :class="fullIconName"></i>
        <img v-if="iconSrc" :src="iconSrc" width="25" height="25">
      </span>
      &nbsp;
      <!--{{header}} <sup v-if="label" class="headerLabel">{{label}}</sup>-->
      <b-badge v-if="greendot" class="badge rounded-f" variant="warning" pill>{{badge}}</b-badge>
    </a>
  </li>
  <li v-else-if="childrenLinks" :class="{headerLink: true, className}">
    <div @click="() => togglePanelCollapse(link)">
      <router-link v-if="!external" :to="link" event="" class="d-flex">
        <span class="icon">
          <i v-if="iconName" :class="fullIconName"></i>
          <img v-if="iconSrc" :src="iconSrc" width="25" height="25">
        </span>
        <!-- {{header}} <sup v-if="label" class="headerLabel">{{label}}</sup> -->
        <div :class="{caretWrapper: true, carretActive: isActive}">
          <i class="fa fa-angle-left" />
        </div>
      </router-link>
      <a v-if="external" :href="link" target="_blank">
        <span class="icon">
          <i v-if="iconName" :class="fullIconName"></i>
          <img v-if="iconSrc" :src="iconSrc" width="25" height="25">
        </span>
        <!-- {{header}} <sup v-if="label" class="headerLabel">{{label}}</sup> -->
        <div :class="{caretWrapper: true, carretActive: isActive}">
          <i class="fa fa-angle-left" />
        </div>
      </a>
    </div>
    <b-collapse :id="'collapse' + index" :visible="isActive">
      <ul>
        <NavLink v-for="link in childrenLinks"
          :activeItem="activeItem"
          :header="link.header"
          :index="link.index"
          :link="link.link"
          :childrenLinks="link.childrenLinks"
          :key="link.link"
        />
      </ul>
    </b-collapse>
  </li>
  <li v-else>
    <router-link :to="index !== 'menu' && link">
      {{header}} <sup v-if="label" class="headerLabel">{{label}}</sup>
    </router-link>
  </li>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'NavLink',
  props: {
    greendot: { type: Boolean, default: false},
    badge: { type: String, dafault: '' },
    header: { type: String, default: '' },
    iconName: { type: String, default: '' },
    iconSrc: { type: String, default: '' },
    headerLink: { type: String, default: '' },
    link: { type: String, default: '' },
    external: { type: Boolean, default: false},
    childrenLinks: { type: Array, default: null },
    className: { type: String, default: '' },
    isHeader: { type: Boolean, default: false },
    deep: { type: Number, default: 0 },
    activeItem: { type: String, default: '' },
    label: { type: String },
    index: { type: String },
  },
  data() {
    return {
      headerLinkWasClicked: true,
    };
  },
  methods: {
    ...mapActions('layout', ['changeSidebarActive']),
    togglePanelCollapse(link) {
      this.changeSidebarActive(link);
      this.headerLinkWasClicked = !this.headerLinkWasClicked
      || !this.activeItem.includes(this.index);
    },
  },
  computed: {
    fullIconName() {
      return `fa ${this.iconName}`;
    },
    isActive() {
      return (this.activeItem
      && this.activeItem.includes(this.index)
      && this.headerLinkWasClicked);
    },
  },
};
</script>

<style src="./NavLink.scss" lang="scss" scoped />
